import { Component, ElementRef, EventEmitter, HostListener, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { Placement } from '@ng-bootstrap/ng-bootstrap/util/positioning';
import { TooltipDirective } from '../tooltip.directive';
import { TooltipService } from '../tooltip.service';

@Component({
  selector: 'yat-tooltip-info-icon',
  templateUrl: './tooltip-info-icon.component.html',
  styleUrls: ['./tooltip-info-icon.component.scss']
})
export class TooltipInfoIconComponent {
  constructor(private tooltipService: TooltipService, private elRef: ElementRef) {}
  @Input()
  id: string;

  @Input()
  iconClass: string;

  @Input()
  tooltipContent: string | TemplateRef<any>;

  @Input()
  tooltipClass: string;

  @Input()
  appendToBody: boolean;

  @Input()
  applyHoverState: boolean;

  /** only centered placements are recognized */
  @Input()
  tooltipPlacement: Placement[];

  @Input()
  manualTooltip: boolean;

  @Output()
  mouseEnter: EventEmitter<null> = new EventEmitter();

  @ViewChild(TooltipDirective)
  tooltip: TooltipDirective;

  @ViewChild('icon')
  icon: ElementRef<HTMLImageElement>;

  @HostListener('touchstart', ['$event'])
  toggleTooltip(event: TouchEvent): void {
    event.target === this.icon.nativeElement ? this.toggleTooltip(event) : this.closeTooltip();
    event.preventDefault();
    if (!this.elRef.nativeElement.contains(event.target) || this.tooltipService.isActive(this.tooltip)) {
      this.closeTooltip();
    } else {
      this.openTooltip();
    }
  }

  openTooltip(): void {
    this.tooltipService.registerTooltip(this.tooltip);
  }

  closeTooltip(): void {
    this.tooltipService.deregisterTooltip(this.tooltip);
  }
}
